import axios from 'axios';
import { getQueryStringObject, checkSessionQueryParams } from '../utility/helper';
import { getConfig } from '../utility/env';
import { sharedConfig } from '../config/shared/config';
import { bootstrapHeaders } from '../utility/global-constants/queryKeys';
import { recordErrorBoundarySpan } from '../utility/otelSetup';

const bootstrapQueryParams = getQueryStringObject();
const env = getConfig();

export async function getContentData() {
  const fullContentRouteName = `${env.content.baseUrl}${sharedConfig.frictionLess.routes.content}`;
  const { data } = await axios.get(fullContentRouteName);
  return data.data;
}

export async function getBootstrapData() {
  if (checkSessionQueryParams()) {
    const fullBootstrapRouteName = `${env.eSign.baseUrl}${sharedConfig.frictionLess.routes.bootstrap}`;
    const { data } = await axios.post(fullBootstrapRouteName, bootstrapQueryParams, { headers: bootstrapHeaders });
    return data.data;
  } else {
    return {
      isError: true,
    };
  }
}

export async function getInitializeData(token) {
  bootstrapHeaders['Authorization'] = token;
  const fullInitializeRouteName = `${env.eSign.baseUrl}${sharedConfig.frictionLess.routes.initialize}`;
  const { data } = await axios.post(fullInitializeRouteName, bootstrapQueryParams, { headers: bootstrapHeaders });
  return data.data;
}

export async function getUpdateOrder(token, sessionId) {
  bootstrapHeaders['Authorization'] = token;
  const fullUpdateRouteName = `${env.eSign.baseUrl}${sharedConfig.frictionLess.routes.update}?id=${sessionId}`;
  try {
    const { data } = await axios.post(fullUpdateRouteName, '', { headers: bootstrapHeaders });
    return data;
  } catch (error) {
    if (error && error?.response?.status === 504) {
      // Added 5 Sec delay to update cache incase of 504 gateway timeout
      if (env?.updateCall504DelayEnabled) await new Promise((resolve) => setTimeout(resolve, 5000));
      const { data } = await axios.post(fullUpdateRouteName, '', { headers: bootstrapHeaders });
      return data;
    } else if (error && !error.response) {
      // handling CORS issue or error without response
      const err = {
        response: {
          data: {
            status: 'Failure',
          },
        },
      };
      return err;
    }
    return error;
  }
}

export async function getCreateUser(token, userData) {
  bootstrapHeaders['Authorization'] = token;
  bootstrapHeaders['Content-Type'] = 'application/json';
  const fullCreateUserRouteName = `${env.eSign.baseUrl}${sharedConfig.frictionLess.routes.createUser}`;
  const { data } = await axios.post(fullCreateUserRouteName, userData, { headers: bootstrapHeaders });
  return data;
}

export async function getInviteUser(token, userData) {
  bootstrapHeaders['Authorization'] = token;
  bootstrapHeaders['Content-Type'] = 'application/json';
  const fullCreateUserRouteName = `${env.eSign.baseUrl}${sharedConfig.frictionLess.routes.inviteUser}`;
  const { data } = await axios.post(fullCreateUserRouteName, userData, { headers: bootstrapHeaders });
  return data.data;
}

export async function uploadDocument(requestBody, token) {
  bootstrapHeaders['Authorization'] = token;
  const fullUploadRouteName = `${env.eSign.baseUrl}${sharedConfig.frictionLess.routes.uploadDocument}`;
  const { data } = await axios.post(fullUploadRouteName, requestBody, { headers: bootstrapHeaders });
  return data;
}

export async function uploadDocumentToS3Bucket(requestBody, url) {
  const { data } = await axios.post(url, requestBody, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
}

export async function uploadDocumentStatus(requestBody, token) {
  bootstrapHeaders['Authorization'] = token;
  const fullUploadRouteName = `${env.eSign.baseUrl}${sharedConfig.frictionLess.routes.updateStatus}`;
  const { data } = await axios.post(fullUploadRouteName, requestBody, { headers: bootstrapHeaders });
  return data;
}

export async function getOnboardingUrl(params) {
  const [cimaToken, sessionId] = params.queryKey;
  bootstrapHeaders['Authorization'] = cimaToken;
  bootstrapHeaders['Content-Type'] = 'application/json';
  const fullOnboardingUrlRouteName = `${env.eSign.baseUrl}${sharedConfig.frictionLess.routes.onboardingUrl}${sessionId}`;
  const { data } = await axios.get(fullOnboardingUrlRouteName, { headers: bootstrapHeaders });
  return data.data;
}

const logErrorBoundaryMessage = (message) => {
  recordErrorBoundarySpan(
    {
      name: 'ErrorBoundaryError',
      message: message || 'ErrorBoundary JS error',
    },
    {
      componentStack: '',
    }
  );
};

// Legacy SA-log API is intentionally disabled after OTel migration.
const logMessage = async () => Promise.resolve();

// Legacy SA-log API is intentionally disabled after OTel migration.
const serviceLogging = async () => Promise.resolve();

const api = {
  logErrorBoundaryMessage,
  logMessage,
  serviceLogging,
};

export default api;
